'use strict';

import React from 'react';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  cardInfo,
  handleAppearanceData,
  handleReportOptions,
  handleSortListData,
  setGraphColors,
} from './report_actions';
import { reRender } from '../skills_action';
import { BgColorsOutlined } from '@ant-design/icons';
import { Button } from 'antd';
const defaultColors = [
  '#B399FE',
  '#25CDA5',
  '#33B6E0',
  '#3F8EEB',
  '#58C8D8',
  '#6EA0DA',
  '#82E3AB',
  '#845FD8',
  '#BAAFF3',
  '#D066D7',
  '#D93C95',
  '#F35074',
  '#FA9B65',
  '#FC7E91',
  '#FFC849',
];
class ColorPicker extends React.Component {
  state = {
    displayColorPicker: false,
    color: {
      r: '241',
      g: '112',
      b: '19',
      a: '1',
    },
  };

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
    this.props.changeColor(this.props.value.color, this.props.value);
  };

  handleChange = (color) => {
    let { updatedData, value, hiddenFields } = this.props;
    this.setState({ color: color.rgb });
    // this.props.value.color=color.hex
    updatedData = updatedData.map((data) => {
      if (data.id === value.id) {
        // data.color = document.getElementById(value.name).value;
        data.color = color.hex;
        return data;
      } else return data;
    });
    this.props.reRender([...updatedData, ...hiddenFields]);

    // this.props.changeColor(color.hex, this.props.value)
  };

  onClickOutsideListener = () => {
    this.state.displayColorPicker && this.handleClose();
    document.removeEventListener('click', this.onClickOutsideListener);
  };

  render() {
    const styles = reactCSS({
      default: {
        color: {
          //   width: '36px',
          //   height: '14px',
          //   borderRadius: '2px',

          'margin-left': '8px',
          border: 'none',
          'font-size': '16px',
          width: '32px',
          background: this.props.value.color
            ? this.props.value.color
            : '#B399FE',
        },
        swatch: {
          //   padding: '5px',
          //   background: '#fff',
          //   borderRadius: '1px',
          //   boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          //   display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          color: 'black',
          position: 'absolute',
          zIndex: '2',
        },
      },
    });

    return (
      <div>
        <div style={styles.swatch} onClick={this.handleClick}>
          <Button style={styles.color}>
            <span style={{ display: 'flex', justifyContent: 'center' }}>
              <BgColorsOutlined />
            </span>
          </Button>
        </div>
        {this.state.displayColorPicker ? (
          <div
            style={styles.popover}
            onMouseLeave={() => {
              document.addEventListener('click', this.onClickOutsideListener);
            }}
          >
            <SketchPicker
              color={this.state.color}
              onChange={this.handleChange}
              presetColors={defaultColors}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withRouter(
  connect(null, {
    reRender,
  })(ColorPicker)
);
